if (!window.hasOwnProperty("TTG.FantasyFootball")) {

  console.log("Tabletop Goodies - Script - Fantasy Football");
  TTG.Html.loadCSS("//www.tabletopgoodies.com/cdn/shop/t/24/assets/_ttg.fantasy-football.css?v=140801737034606132701790019900");
  
TTG = (function (parent) {
  const result = {};

  const _createBaseLabel = (number, color) =>
  {
    const normalizedColor = TTG.Colors.normalize(color);
     const base = $(`<div class='fantasy-football-base product-color-background-container' data-background-color='${normalizedColor}' data-number='${number}'><div class='fantasy-football-base-label product-color-background' ></div></div>`); 
     const finalNumber = Number(number);
    const numberDiv = base.find('div');
    if(TTG.isNumber(finalNumber))
    {
      numberDiv.text(finalNumber);
    }
    else if(number == 'star' || number == 'Star' || number == 'STAR')
    {
          if(normalizedColor === 'white')
          {
          numberDiv.html("<img src='https://tabletopgoodiescdn.blob.core.windows.net/store/icons/512x512/star_black.png' src='*' width='23px' height='23px' />")
          }
          else{
          numberDiv.html("<img src='https://tabletopgoodiescdn.blob.core.windows.net/store/icons/512x512/star_white.png' src='*' width='23px' height='23px' />")
          }
    }
    return base;
  }
    
  result.SkillsByCategory = {
    general: [
      "block",
      "dauntless",
      "fend",
      "frenzy",
      "kick",
      "pro",
      "steady_footing",
      "strip_ball",
      "sure_hands",
      "tackle",
      "taunt",
      "wrestle",
    ],
    agility: [
      "catch",
      "diving_catch",
      "diving_tackle",
      "dodge",
      "defensive",
      "jump_up",
      "leap",
      "safe_pair_of_hands",
      "sidestep",
      "hit_and_run",
      "sprint",
      "sure_feet",
    ],
    mutations: [
      "big_hand",
      "claws",
      "disturbing_presence",
      "extra_arms",
      "foul_appearance",
      "horns",
      "iron_hard_skin",
      "monstrous_mouth",
      "prehensile_tail",
      "tentacles",
      "two_heads",
      "very_long_legs",
    ],
    passing: [
      "accurate",
      "cannoneer",
      "cloud_burster",
      "dump_off",
      "hail_mary_pass",
      "leader",
      "nerves_of_steel",
      "on_the_ball",
      "pass",
      "punt",
      "give_and_go",
      "safe_pass"
    ],
    devious:
    [
      "dirty_player_1",
      "dirty_player_2",
      "eye_gouge",
      "fumblerooskie",
      "lethal_flight",
      "lone_fouler",
      "pile_driver",
      "put_the_boot_in",
      "quick_foul",
      "saboteur",
      "shadowing",
      "sneaky_git",
      "violent_innovateur"
    ],
    strength: [
      "arm_bar",
      "brawler",
      "break_tackle",
      "grab",
      "guard",
      "juggernaut",
      "mighty_blow_1",
      "mighty_blow_2",
      "multiple_block",
      "bullseye",
      "stand_firm",
      "strong_arm",
      "thick_skull",
    ],
    traits: [
      "animosity",
      "stunty",
      "right_stuff",
      "always_hungry",
      "loner_5",
      "loner_4",
      "loner_3",
      "loner_2",
      "animal_savagery",
      "throw_team_mate",
      "projectile_vomit",
      "really_stupid",
      "regeneration",
      "unchannelled_fury",
      "unsteady",
      "insignificant",
      "hatred",
      "secret_weapon",
      "chainsaw",
      "ball_and_chain",
      "pogo_stick",
      "swoop",
      "timmm_ber",
      "take_root",
      "plague_ridden",
      "titchy",
      "swarming",
      "hypnotic_gaze",
      "kick_team_mate",
      "breath_fire",
      "bone_head",
      "pick_me_up",
      "decay",
      "trickster",
      "no_ball",
      "my_ball",
      "stab",
      "drunkard",
      "bloodlust",
      "special",
      "niggling_injury",
      "niggling_injuries_2",
    ],
    characteristics: [
      "ma_1p",
      "st_1p",
      "ag_1p",
      "pa_1p",
      "av_1p",
      "ma_1m",
      "st_1m",
      "ag_1m",
      "pa_1m",
      "av_1m",
    ],
  };
  result.SkillSets = {
    standard: {
      skills: {
        block: 6,
        dauntless: 1,
        dirty_player_1: 1,
        fend: 1,
        frenzy: 1,
        kick: 1,
        pro: 1,
        shadowing: 1,
        strip_ball: 1,
        sure_hands: 1,
        tackle: 1,
        wrestle: 1,
        catch: 1,
        diving_catch: 1,
        diving_tackle: 1,
        dodge: 6,
        defensive: 1,
        jump_up: 1,
        leap: 1,
        safe_pair_of_hands: 1,
        sidestep: 1,
        sneaky_git: 1,
        sprint: 1,
        sure_feet: 1,
        big_hand: 1,
        claws: 2,
        disturbing_presence: 1,
        extra_arms: 1,
        foul_appearance: 1,
        horns: 2,
        iron_hard_skin: 1,
        monstrous_mouth: 1,
        prehensile_tail: 1,
        tentacles: 1,
        two_heads: 1,
        very_long_legs: 1,
        accurate: 1,
        cannoneer: 1,
        cloud_burster: 1,
        dump_off: 1,
        fumblerooskie: 1,
        hail_mary_pass: 1,
        leader: 1,
        nerves_of_steel: 1,
        on_the_ball: 1,
        pass: 1,
        give_and_go: 1,
        safe_pass: 1,
        arm_bar: 1,
        brawler: 1,
        break_tackle: 1,
        grab: 1,
        guard: 2,
        juggernaut: 2,
        mighty_blow_1: 2,
        multiple_block: 1,
        pile_driver: 1,
        stand_firm: 1,
        strong_arm: 1,
        thick_skull: 1,
      },
      traits: {
        loner_4: 2,
        loner_2: 1,
        projectile_vomit: 1,
        stab: 1,
        special: 1,
        niggling_injury: 1,
        niggling_injuries_2: 1,
      },
      characteristics: {
        ma_1p: 1,
        st_1p: 1,
        ag_1p: 1,
        pa_1p: 1,
        av_1p: 1,
        ma_1m: 1,
        st_1m: 1,
        ag_1m: 1,
        pa_1m: 1,
        av_1m: 1,
      },
    },

    extended: {
      skills: {
        block: 8,
        dauntless: 2,
        dirty_player_1: 2,
        fend: 2,
        frenzy: 2,
        kick: 2,
        pro: 2,
        shadowing: 2,
        strip_ball: 2,
        sure_hands: 2,
        tackle: 2,
        wrestle: 2,

        catch: 2,
        diving_catch: 2,
        diving_tackle: 2,
        dodge: 6,
        defensive: 2,
        jump_up: 2,
        leap: 2,
        safe_pair_of_hands: 2,
        sidestep: 2,
        sneaky_git: 2,
        sprint: 2,
        sure_feet: 2,

        big_hand: 2,
        claws: 4,
        disturbing_presence: 2,
        extra_arms: 2,
        foul_appearance: 2,
        horns: 4,
        iron_hard_skin: 2,
        monstrous_mouth: 2,
        prehensile_tail: 2,
        tentacles: 2,
        two_heads: 2,
        very_long_legs: 2,

        accurate: 2,
        cannoneer: 2,
        cloud_burster: 2,
        dump_off: 2,
        fumblerooskie: 2,
        hail_mary_pass: 2,
        leader: 2,
        nerves_of_steel: 2,
        on_the_ball: 2,
        pass: 2,
        running_pass: 2,
        safe_pass: 2,

        arm_bar: 2,
        brawler: 2,
        break_tackle: 2,
        grab: 2,
        guard: 4,
        juggernaut: 4,
        mighty_blow_1: 4,
        multiple_block: 2,
        pile_driver: 2,
        stand_firm: 2,
        strong_arm: 2,
        thick_skull: 2,
      },
      traits: {
        loner_4: 2,
        loner_2: 1,
        projectile_vomit: 1,
        stab: 1,
        special: 1,
        niggling_injury: 1,
        niggling_injuries_2: 1,
      },
      characteristics: {
        ma_1p: 1,
        st_1p: 1,
        ag_1p: 1,
        pa_1p: 1,
        av_1p: 1,
        ma_1m: 1,
        st_1m: 1,
        ag_1m: 1,
        pa_1m: 1,
        av_1m: 1,
      },
    },

    general: {
      skills: {
        block: 1,
        dauntless: 1,
        taunt: 1,
        steady_footing: 1,
        fend: 1,
        frenzy: 1,
        kick: 1,
        pro: 1,
        strip_ball: 1,
        sure_hands: 1,
        tackle: 1,
        wrestle: 1,
      },
      traits: {},
      characteristics: {},
    },

    agility: {
      skills: {
        catch: 1,
        diving_catch: 1,
        diving_tackle: 1,
        dodge: 1,
        defensive: 1,
        jump_up: 1,
        leap: 1,
        safe_pair_of_hands: 1,
        sidestep: 1,
        hit_and_run: 1,
        sprint: 1,
        sure_feet: 1,
      },
      traits: {},
      characteristics: {},
    },

    mutations: {
      skills: {
        big_hand: 1,
        claws: 1,
        disturbing_presence: 1,
        extra_arms: 1,
        foul_appearance: 1,
        horns: 1,
        iron_hard_skin: 1,
        monstrous_mouth: 1,
        prehensile_tail: 1,
        tentacles: 1,
        two_heads: 1,
        very_long_legs: 1,
      },
      traits: {},
      characteristics: {},
    },

    passing: {
      skills: {
        accurate: 1,
        cannoneer: 1,
        cloud_burster: 1,
        dump_off: 1,
        punt: 1,
        hail_mary_pass: 1,
        leader: 1,
        nerves_of_steel: 1,
        on_the_ball: 1,
        pass: 1,
        give_and_go: 1,
        safe_pass: 1,
      },
      traits: {},
      characteristics: {},
    },

    strength: {
      skills: {
        arm_bar: 1,
        brawler: 1,
        break_tackle: 1,
        grab: 1,
        guard: 1,
        juggernaut: 1,
        mighty_blow_1: 1,
        multiple_block: 1,
        bullseye: 1,
        stand_firm: 1,
        strong_arm: 1,
        thick_skull: 1,
      },
      traits: {},
      characteristics: {},
    },

    traits: {
      skills: {},
      traits: {
        bombardier: 1,
        animosity: 1,
        stunty: 1,
        right_stuff: 1,
        always_hungry: 1,
        insignificant: 1,
        hatred: 1,

        loner_5: 1,
        loner_4: 1,
        loner_3: 1,
        loner_2: 1,
        animal_savagery: 1,
        throw_team_mate: 1,
        projectile_vomit: 1,
        really_stupid: 1,
        regeneration: 1,
        unchannelled_fury: 1,
        no_ball: 1,
        secret_weapon: 1,
        chainsaw: 1,
        ball_and_chain: 1,
        pogo_stick: 1,
        swoop: 1,
        timmm_ber: 1,
        take_root: 1,
        plague_ridden: 1,
        titchy: 1,
        swarming: 1,
        hypnotic_gaze: 1,
        kick_team_mate: 1,
        breath_fire: 1,
        bone_head: 1,
        pick_me_up: 1,
        decay: 1,
        trickster: 1,
        my_ball: 1,
        stab: 1,
        drunkard: 1,
        bloodlust: 1,
        special: 1,
        unsteady: 1,
        niggling_injury: 1,
        niggling_injuries_2: 1,
      },
      characteristics: {},
    },

    characteristics: {
      skills: {},
      traits: {},
      characteristics: {
        ma_1p: 1,
        st_1p: 1,
        ag_1p: 1,
        pa_1p: 1,
        av_1p: 1,
        ma_1m: 1,
        st_1m: 1,
        ag_1m: 1,
        pa_1m: 1,
        av_1m: 1,
      },
    },

  };

  result.Strings = {};

  result.Strings["en"] = {
    positions: {
      blitzer: "Blitzer",
      lineman: "Lineman",
      thrower: "Thrower",
      catcher: "Catcher",
      blocker: "Blocker",
      special: "Special",
      star_player: "Star Player",
      journeyman: "Journeyman",
    },
    skill_types: {
      skill: "Skill",
      trait: "Trait",
      characteristic: "Characterstic",
    },
    skill_categories: {
      general: "General",
      agility: "Agility",
      mutations: "Mutations",
      passing: "Passing",
      strength: "Strength",
      devious: "Devious",
      traits: "Traits",
      characteristics: "Characteristics",
    },
    skills: {
      // Season 3
      eye_gouge: "Eye Gouge",
      lethal_flight: "Lethal Flight",
      lone_fouler: "Lone Fouler",
      put_the_boot_in: "Put the Boot In",
      quick_foul: "Quick Foul",
      saboteur: "Saboteur",
      violent_innovateur: "Violent Innovator",
      bullseye: "Bullseye",
      give_and_go: "Give and Go",
      taunt: "Taunt",
      steady_footing: "Steady Footing",
      punt: "Punt",
      hatred: "Hatred",
      insignificant: "Insignificant",
      no_ball: "No Ball",
      unsteady: "Unsteady",

      dirty_player_1: "Dirty Player (+1)",
      dirty_player_2: "Dirty Player (+2)",

      bombardier: "Bombardier",
      block: "Block",
      dauntless: "Dauntless",
      fend: "Fend",
      frenzy: "Frenzy",
      kick: "Kick",
      pro: "Pro",
      shadowing: "Shadowing",
      strip_ball: "Strip Ball",
      sure_hands: "Sure Hands",
      tackle: "Tackle",
      wrestle: "Wrestle",
      catch: "Catch",
      diving_catch: "Diving Catch",
      diving_tackle: "Diving Tackle",
      dodge: "Dodge",
      defensive: "Defensive",
      jump_up: "Jump Up",
      leap: "Leap",
      safe_pair_of_hands: "Safe Pair of Hands",
      sidestep: "Sidestep",
      sneaky_git: "Sneaky Git",
      sprint: "Sprint",
      sure_feet: "Sure Feet",
      big_hand: "Big Hand",
      claws: "Claws",
      disturbing_presence: "Disturbing Presence",
      extra_arms: "Extra Arms",
      foul_appearance: "Foul Appearance",
      horns: "Horns",
      iron_hard_skin: "Iron Hard Skin",
      monstrous_mouth: "Monstrous Mouth",
      prehensile_tail: "Prehensile Tail",
      tentacles: "Tentacles",
      two_heads: "Two Heads",
      very_long_legs: "Very Long Legs",
      accurate: "Accurate",
      cannoneer: "Cannoneer",
      cloud_burster: "Cloud Burster",
      dump_off: "Dump-Off",
      fumblerooskie: "Fumblerooskie",
      hail_mary_pass: "Hail Mary Pass",
      leader: "Leader",
      nerves_of_steel: "Nerves of Steel",
      on_the_ball: "On the Ball",
      pass: "Pass",
      running_pass: "Running Pass",
      safe_pass: "Safe Pass",
      arm_bar: "Arm Bar",
      brawler: "Brawler",
      break_tackle: "Break Tackle",
      grab: "Grab",
      guard: "Guard",
      juggernaut: "Juggernaut",
      mighty_blow_1: "Mighty Blow (+1)",
      mighty_blow_2: "Mighty Blow (+2)",
      multiple_block: "Multiple Block",
      pile_driver: "Pile Driver",
      stand_firm: "Stand Firm",
      strong_arm: "Strong Arm",
      thick_skull: "Thick Skull",
      ma_1p: "MA +1",
      st_1p: "ST +1",
      ag_1p: "AG +1",
      pa_1p: "PA +1",
      av_1p: "AV +1",
      ma_1m: "MA -1",
      st_1m: "ST -1",
      ag_1m: "AG -1",
      pa_1m: "PA -1",
      av_1m: "AV -1",
      animosity: "Animosity",
      stunty: "Stunty",
      right_stuff: "Right Stuff",
      always_hungry: "Always Hungry",
      loner_5: "Loner (5+)",
      loner_4: "Loner (4+)",
      loner_3: "Loner (3+)",
      loner_2: "Loner (2+)",
      animal_savagery: "Animal Savagery",
      throw_team_mate: "Throw Teammate",
      projectile_vomit: "Projectile Vomit",
      really_stupid: "Really Stupid",
      regeneration: "Regeneration",
      unchannelled_fury: "Unchannelled Fury",
      no_hands: "No Hands",
      secret_weapon: "Secret Weapon",
      chainsaw: "Chainsaw",
      ball_and_chain: "Ball & Chain",
      pogo_stick: "Pogo Stick",
      swoop: "Swoop",
      timmm_ber: "Timmm-Ber!",
      take_root: "Take Root",
      plague_ridden: "Plague Ridden",
      titchy: "Titchy",
      swarming: "Swarming",
      hypnotic_gaze: "Hypnotic Gaze",
      kick_team_mate: "Kick Teammate",
      breath_fire: "Breath Fire",
      bone_head: "Bone Head",
      pick_me_up: "Pick-me-up",
      decay: "Decay",
      trickster: "Trickster",
      hit_and_run: "Hit and Run",
      my_ball: "My Ball",
      stab: "Stab",
      drunkard: "Drunkard",
      bloodlust: "Bloodlust",
      special: "Special",
      niggling_injury: "Niggling Injury (1)",
      niggling_injuries_2: "Niggling Injuries (2+)",
    },
    skill_hooks: {

       // Season 3
      eye_gouge: "EYE GOUGE",
      lethal_flight: "LETHAL F.",
      lone_fouler: "L. FOULER",
      put_the_boot_in: "P.T. BOOT IN",
      quick_foul: "QUICK FOUL",
      saboteur: "SABOTEUR",
      violent_innovateur: "VIOLENT IN.",
      bullseye: "BULLSEYE",
      give_and_go: "GIVE & GO",
      taunt: "TAUNT",
      steady_footing: "STEADY F.",
      punt: "PUNT",
      hatred: "HATRED",
      insignificant: "INSIG.",
      no_ball: "NO BALL",
      unsteady: "UNSTEADY",
      dirty_player_1: "DIRTY P.(+1)",
      dirty_player_2: "DIRTY P.(+2)",

      bombardier: "BOMBAR.",
      block: "BLOCK",
      dauntless: "DAUNTLESS",
      fend: "FEND",
      frenzy: "FRENZY",
      kick: "KICK",
      pro: "PRO",
      shadowing: "SHADOW.",
      strip_ball: "STP.BALL",
      sure_hands: "S.HANDS",
      tackle: "TACKLE",
      wrestle: "WRESTLE",
      catch: "CATCH",
      diving_catch: "DI.CATCH",
      diving_tackle: "DI.TACKLE",
      dodge: "DODGE",
      defensive: "DEFENSIVE",
      jump_up: "JUMP UP",
      leap: "LEAP",
      safe_pair_of_hands: "S.P. HANDS",
      sidestep: "SIDESTEP",
      sneaky_git: "SNEAKY G.",
      sprint: "SPRINT",
      sure_feet: "S.FEET",
      big_hand: "BIG HAND",
      claws: "CLAWS",
      disturbing_presence: "D.PRESENCE",
      extra_arms: "EX. ARMS",
      foul_appearance: "FOUL APP.",
      horns: "HORNS",
      iron_hard_skin: "I.H.SKIN",
      monstrous_mouth: "M.MOUTH",
      prehensile_tail: "PRE.TAIL",
      tentacles: "TENTACLES",
      two_heads: "2 HEADS",
      very_long_legs: "V.L.LEGS",
      accurate: "ACCURATE",
      cannoneer: "CANNON.",
      cloud_burster: "C.BURSTER",
      dump_off: "DUMP-OFF",
      fumblerooskie: "F.ROOSKIE",
      hail_mary_pass: "H.M.PASS",
      leader: "LEADER",
      nerves_of_steel: "N.O.STEEL",
      on_the_ball: "O.T.BALL",
      pass: "PASS",
      running_pass: "RUN.PASS",
      safe_pass: "SAFE PASS",
      arm_bar: "ARM BAR",
      brawler: "BRAWLER",
      break_tackle: "BR.TACKLE",
      grab: "GRAB",
      guard: "GUARD",
      juggernaut: "JUGGERNAUT",
      mighty_blow_1: "M.BLOW (+1)",
      mighty_blow_2: "M.BLOW (+2)",
      multiple_block: "M.BLOCK",
      pile_driver: "PL. DRIVER",
      stand_firm: "ST.FIRM",
      strong_arm: "STR.ARM",
      thick_skull: "TH.SKULL",
      ma_1p: "MA +1",
      st_1p: "ST +1",
      ag_1p: "AG +1",
      pa_1p: "PA +1",
      av_1p: "AV +1",
      ma_1m: "MA -1",
      st_1m: "ST -1",
      ag_1m: "AG -1",
      pa_1m: "PA -1",
      av_1m: "AV -1",
      animosity: "ANIMOSITY",
      stunty: "STUNTY",
      right_stuff: "R.STUFF",
      always_hungry: "A.HUNGRY",
      loner_5: "LONER (5+)",
      loner_4: "LONER (4+)",
      loner_3: "LONER (3+)",
      loner_2: "LONER (2+)",
      animal_savagery: "A.SAVAGERY",
      throw_team_mate: "THROW TM",
      projectile_vomit: "PRJ.VOMIT",
      really_stupid: "RLY.STUPID",
      regeneration: "REGEN.",
      unchannelled_fury: "UN.FURY",
      no_hands: "NO HANDS",
      secret_weapon: "S.WEAPON",
      chainsaw: "CHAINSAW",
      ball_and_chain: "BALL&CH.",
      pogo_stick: "POGO ST.",
      swoop: "SWOOP",
      timmm_ber: "TIM.BER",
      take_root: "TK.ROOT",
      plague_ridden: "PLAGUE R.",
      titchy: "TITCHY",
      swarming: "SWARMING",
      hypnotic_gaze: "HYPN.GAZ.",
      kick_team_mate: "KICK TM",
      breath_fire: "B.FIRE",
      bone_head: "BONE HEAD",
      pick_me_up: "P.M.UP",
      decay: "DECAY",
      trickster: "TRICKSTER",
      hit_and_run: "H.& RUN",
      my_ball: "MY BALL",
      stab: "STAB",
      drunkard: "DRUNKARD",
      bloodlust: "BLOODLUST",
      special: "SPECIAL",
      niggling_injury: "N.INJ. (1)",
      niggling_injuries_2: "N.INJ. (2+)",
    },
  };
  
  result.Strings["fr"] = {
    positions: {
      blitzer: "Blitzer",
      lineman: "Trois-quarts",
      thrower: "Lanceur",
      catcher: "Reveveur",
      blocker: "Bloqueur",
      special: "Spécial",
      star_player: "Joueur étoile",
      journeyman: "Mercenaire",
    },
    skill_types: {
      skill: "Compétence",
      trait: "Trait",
      characteristic: "Caractéristique",
    },
    skill_categories: {
      general: "Général",
      agility: "Agilité",
      mutations: "Mutations",
      passing: "Passe",
      strength: "Force",
      traits: "Traits",
      characteristics: "Caractéristiques",
    },
    skills: {
    // Season 3
      eye_gouge: "Fourchette",
      lethal_flight: "Vol Fatal",
      lone_fouler: "Agresseur Solitaire",
      put_the_boot_in: "Copu de Crampons",
      quick_foul: "Agression Éclair",
      saboteur: "Saboteur",
      violent_innovateur: "Innovateur Violent",
      bullseye: "Dans le Mille",
      give_and_go: "Transmission dans la course",
      taunt: "Provocation",
      steady_footing: "Appuis Sûrs",
      punt: "Dégagement",
      hatred: "Haine",
      insignificant: "Insignifiant",
      no_ball: "Sans Ballon",
      unsteady: "Instable",

      bombardier: "Bombardier",
      block: "Blocage",
      dauntless: "Intrépide",
      dirty_player_1: "Joueur déloyal (+1)",
      dirty_player_2: "Joueur déloyal (+2)",
      fend: "Parade",
      frenzy: "Frénésie",
      kick: "Frappe précise",
      pro: "Pro",
      shadowing: "Poursuite",
      strip_ball: "Arracher le ballon",
      sure_hands: "Prise sûre",
      tackle: "Tacle",
      wrestle: "Lutte",
      catch: "Réception",
      diving_catch: "Réception plongeante",
      diving_tackle: "Tacle plongeant",
      dodge: "Esquive",
      defensive: "Défenseur",
      jump_up: "Rétablissement",
      leap: "Saut",
      safe_pair_of_hands: "Libération contrôlée",
      sidestep: "Glissage contrôlée",
      sneaky_git: "Sournois",
      sprint: "Sprint",
      sure_feet: "Équilibre",
      big_hand: "Main démesurée",
      claws: "Griffes",
      disturbing_presence: "Présence perturbante",
      extra_arms: "Bras supplémentaires",
      foul_appearance: "Répulsion",
      horns: "Cornes",
      iron_hard_skin: "Peau de fer",
      monstrous_mouth: "Grande gueule",
      prehensile_tail: "Queue préhensile",
      tentacles: "Tentacules",
      two_heads: "Deux têtes",
      very_long_legs: "Très longues jambes",
      accurate: "Précision",
      cannoneer: "Canonnier",
      cloud_burster: "Perce-nuages",
      dump_off: "Délestage",
      fumblerooskie: "Fumblerooskie",
      hail_mary_pass: "Passe désespérée",
      leader: "Chef",
      nerves_of_steel: "Nerfs d'acier",
      on_the_ball: "Sur le ballon",
      pass: "Passe",
      running_pass: "Passe dans la course",
      safe_pass: "Passe assurée",
      arm_bar: "Clé de bras",
      brawler: "Bagarreur",
      break_tackle: "Esquive en force",
      grab: "Projection",
      guard: "Garde",
      juggernaut: "Juggernaut",
      mighty_blow_1: "Châtaigne (+1)",
      mighty_blow_2: "Châtaigne (+2)",
      multiple_block: "Blocage multiple",
      pile_driver: "Marteau-pilon",
      stand_firm: "Stabilité",
      strong_arm: "Bras musclé",
      thick_skull: "Crâne épais",
      ma_1p: "MV +1",
      st_1p: "FO +1",
      ag_1p: "AG +1",
      pa_1p: "CP +1",
      av_1p: "AR +1",
      ma_1m: "MV -1",
      st_1m: "FO -1",
      ag_1m: "AG -1",
      pa_1m: "CP -1",
      av_1m: "AR -1",
      animosity: "Animosité",
      stunty: "Minus",
      right_stuff: "Poids plume",
      always_hungry: "Toujours affamé",
      loner_5: "Solitaire (5+)",
      loner_4: "Solitaire (4+)",
      loner_3: "Solitaire (3+)",
      loner_2: "Solitaire (2+)",
      animal_savagery: "Sauvagerie animale",
      throw_team_mate: "Lancer de coéquipier",
      projectile_vomit: "Gerbe de vomi",
      really_stupid: "Gros débile",
      regeneration: "Régénération",
      unchannelled_fury: "Fureur débridée",
      no_hands: "Sans les mains",
      secret_weapon: "Arme secrète",
      chainsaw: "Tronçonneuse",
      ball_and_chain: "Chaînes et boulet",
      pogo_stick: "Échasse à ressort",
      swoop: "Piqué",
      timmm_ber: "Timm–Ber !",
      take_root: "Prendre racine",
      plague_ridden: "Contagieux",
      titchy: "Microbe",
      swarming: "Déferlement",
      hypnotic_gaze: "Regard hypnotique",
      kick_team_mate: "Botter de coéquipier",
      breath_fire: "Souffler le feu",
      bone_head: "Cerveau lent",
      pick_me_up: "Choppe-moi",
      decay: "Décomposition",
      trickster: "Farceur",
      hit_and_run: "Frappe et cours",
      my_ball: "Mon ballon",
      stab: "Poignard",
      drunkard: "Poivrot",
      bloodlust: "Soif de sang",
      special: "Spécial",
      niggling_injury: "Blessure persistante (1)",
      niggling_injuries_2: "Blessures persistantes (2+)",
    },
    skill_hooks: {
      // Season 3
      eye_gouge: "FOURCHETTE",
      lethal_flight: "VOL FATAL",
      lone_fouler: "AGG.SOL.",
      put_the_boot_in: "C.D.CRAMPONS",
      quick_foul: "AGG.ÉCLAIR",
      saboteur: "SABOTEUR",
      violent_innovateur: "IN.VIOLENT",
      bullseye: "D.L.MILLE",
      give_and_go: "TRANS.D.L.C",
      taunt: "PROVOCATION",
      steady_footing: "APPUIS S.",
      punt: "DÉGAGEMENT",
      hatred: "HAINE",
      insignificant: "INSIG.",
      no_ball: "SANS BALLON",
      unsteady: "INSTABLE",
      
      bombardier: "BOMBAR.",
      block: "BLOCAGE",
      dauntless: "INTRÉPIDE",
      dirty_player_1: "DÉLOYAL(+1)",
      dirty_player_2: "DÉLOYAL(+2)",
      fend: "PARADE",
      frenzy: "FRÉNÉSIE",
      kick: "F.PRÉCISE",
      pro: "PRO",
      shadowing: "POURSUITE",
      strip_ball: "A.L.BALLON",
      sure_hands: "PRISE SÛRE",
      tackle: "TACLE",
      wrestle: "LUTTE",
      catch: "RÉCEPTION",
      diving_catch: "RÉC.PLONG.",
      diving_tackle: "TAC.PLONG.",
      dodge: "ESQUIVE",
      defensive: "DÉFENSEUR",
      jump_up: "RÉTABLIS.",
      leap: "SAUT",
      safe_pair_of_hands: "LIB.CONTR.",
      sidestep: "GLISS.CONTR.",
      sneaky_git: "SOURNOIS",
      sprint: "SPRINT",
      sure_feet: "ÉQUILIBRE",
      big_hand: "MAIN DEM.",
      claws: "GRIFFES",
      disturbing_presence: "PRÉ.PERTURB.",
      extra_arms: "BRAS SUP.",
      foul_appearance: "RÉPULSION",
      horns: "CORNES",
      iron_hard_skin: "P.D.FER",
      monstrous_mouth: "G.GUEULE",
      prehensile_tail: "QUEUE PRÉ.",
      tentacles: "TENTACULES",
      two_heads: "2 TÊTES",
      very_long_legs: "T.L.JAMBES",
      accurate: "PRÉCISION",
      cannoneer: "CANON.",
      cloud_burster: "P.-NUAGES",
      dump_off: "DÉLEST.",
      fumblerooskie: "F.ROOSKIE",
      hail_mary_pass: "PASSE DÉS.",
      leader: "CHEF",
      nerves_of_steel: "N.D'ACIER",
      on_the_ball: "S.L.BALLON",
      pass: "PASSE",
      running_pass: "PASSE D.L.C.",
      safe_pass: "PASSE ASS.",
      arm_bar: "C.D.BRAS",
      brawler: "BAGARREUR",
      break_tackle: "ESQ.E.FOR.",
      grab: "PROJECTION",
      guard: "GARDE",
      juggernaut: "JUGGERNAUT",
      mighty_blow_1: "CHÂTAIGNE+1",
      mighty_blow_2: "CHÂTAIGNE+2",
      multiple_block: "BL.MULTIPLE",
      pile_driver: "MART.PIL.",
      stand_firm: "STABILITÉ",
      strong_arm: "B.MUSCLÉ",
      thick_skull: "CRÂNE ÉP.",
      ma_1p: "MV +1",
      st_1p: "FO +1",
      ag_1p: "AG +1",
      pa_1p: "CP +1",
      av_1p: "AR +1",
      ma_1m: "MV -1",
      st_1m: "FO -1",
      ag_1m: "AG -1",
      pa_1m: "CP -1",
      av_1m: "AR -1",
      animosity: "ANIMOS.",
      stunty: "MINUS",
      right_stuff: "P.PLUME",
      always_hungry: "T.AFFAMÉ",
      loner_5: "SOLIT. (5+)",
      loner_4: "SOLIT. (4+)",
      loner_3: "SOLIT. (3+)",
      loner_2: "SOLIT. (2+)",
      animal_savagery: "SAUV.ANIM.",
      throw_team_mate: "LANCER CO.",
      projectile_vomit: "G.D.VOMI",
      really_stupid: "GR.DÉBILE",
      regeneration: "RÉGÉN.",
      unchannelled_fury: "FUREUR DÉ.",
      no_hands: "S.L.MAINS",
      secret_weapon: "A.SECRÈTE",
      chainsaw: "TRONÇO.",
      ball_and_chain: "C.&.BOULET",
      pogo_stick: "É.À.RESS.",
      swoop: "PIQUÉ",
      timmm_ber: "TIM.BER",
      take_root: "P.RACINE",
      plague_ridden: "CONTAGIEUX",
      titchy: "MICROBE",
      swarming: "DÉFERL.",
      hypnotic_gaze: "R.HYPNOT.",
      kick_team_mate: "BOTTER CO.",
      breath_fire: "SOUFFLE ARD.",
      bone_head: "CERV.LENT",
      pick_me_up: "CHOPPE-M.",
      decay: "DÉCOMP.",
      trickster: "FARCEUR",
      hit_and_run: "F.& COURS",
      my_ball: "M.BALLON",
      stab: "POIGNARD",
      drunkard: "POIVROT",
      bloodlust: "S.D.SANG",
      special: "SPÉCIAL",
      niggling_injury: "B.PERSI(1)",
      niggling_injuries_2: "B.PERSI(2+)",
    },
  };
    
  result.Strings["es"] = {
    positions: {
      blitzer: "Blitzer",
      lineman: "Trois-quarts",
      thrower: "Lanceur",
      catcher: "Reveveur",
      blocker: "Bloqueur",
      special: "Spécial",
      star_player: "Joueur étoile",
      journeyman: "Mercenaire",
    },
    skill_types: {
      skill: "Compétence",
      trait: "Trait",
      characteristic: "Caractéristique",
    },
    skill_categories: {
      general: "Général",
      agility: "Agilité",
      mutations: "Mutations",
      passing: "Passe",
      strength: "Force",
      traits: "Traits",
      characteristics: "Caractéristiques",
    },
    skills: {

      // Season 3
      eye_gouge: "Eye Gouge",
      lethal_flight: "Lethal Flight",
      lone_fouler: "Lone Fouler",
      put_the_boot_in: "Put the Boot In",
      quick_foul: "Quick Foul",
      saboteur: "Saboteur",
      violent_innovateur: "Violent Innovateur",
      bullseye: "Bullseye",
      give_and_go: "Give and Go",
      taunt: "Taunt",
      steady_footing: "Steady Footing",
      punt: "Punt",
      hatred: "Hatred",
      insignificant: "Insignificant",
      no_ball: "No Ball",
      unsteady: "Unsteady",

      bombardier: "Bombardero",
      block: "Placar",
      dauntless: "Agallas",
      dirty_player_1: "Jugar Sucio (+1)",
      dirty_player_2: "Jugar Sucio (+2)",
      fend: "Zafarse",
      frenzy: "Furia",
      kick: "Patada",
      pro: "Profesional",
      shadowing: "Perseguir",
      strip_ball: "Robar Balón",
      sure_hands: "Manos Seguras",
      tackle: "Placaje Defensivo",
      wrestle: "Forcejear",
      catch: "Atrapar",
      diving_catch: "Recepción Heroica",
      diving_tackle: "Placaje Heroico",
      dodge: "Esquivar",
      defensive: "Romper Defensas",
      jump_up: "En Pie de un Salto",
      leap: "Saltar",
      safe_pair_of_hands: "Proteger el Cuero",
      sidestep: "Echarse a un Lado",
      sneaky_git: "Furtivo",
      sprint: "Esprintar",
      sure_feet: "Pies Firmes",
      big_hand: "Mano Grande",
      claws: "Garras",
      disturbing_presence: "Presencia Perturbadora",
      extra_arms: "Brazos Adicionales",
      foul_appearance: "Apariencia Asquerosa",
      horns: "Cuernos",
      iron_hard_skin: "Piel Férrea",
      monstrous_mouth: "Boca Monstruosa",
      prehensile_tail: "Cola Prénsil",
      tentacles: "Tentáculos",
      two_heads: "Dos Cabezas",
      very_long_legs: "Piernas Muy Largas",
      accurate: "Precisión",
      cannoneer: "Cañonero",
      cloud_burster: "Partenubes",
      dump_off: "Pase Precipitado",
      fumblerooskie: "Dejada",
      hail_mary_pass: "Pase a lo Loco",
      leader: "Líder",
      nerves_of_steel: "Nervios de Acero",
      on_the_ball: "Atento al Balón",
      pass: "Pasar",
      running_pass: "Pase a la carrera",
      safe_pass: "Pase Seguro",
      arm_bar: "Llave de Brazo",
      brawler: "Luchador",
      break_tackle: "Abrirse Paso",
      grab: "Apartar",
      guard: "Defensa",
      juggernaut: "Imparable",
      mighty_blow_1: "Golpe Mortífero (+1)",
      mighty_blow_2: "Golpe Mortífero (+2)",
      multiple_block: "Placaje Múltiple",
      pile_driver: "Crujir",
      stand_firm: "Mantenerse Firme",
      strong_arm: "Brazo Fuerte",
      thick_skull: "Cabeza Dura",
      ma_1p: "MV +1",
      st_1p: "FU +1",
      ag_1p: "AG +1",
      pa_1p: "PS +1",
      av_1p: "AR +1",
      ma_1m: "MV -1",
      st_1m: "FU -1",
      ag_1m: "AG -1",
      pa_1m: "PS -1",
      av_1m: "AR -1",
      animosity: "Animosidad",
      stunty: "Escurridizo",
      right_stuff: "Humanoide Bala",
      always_hungry: "Siempre Hambriento",
      loner_5: "Solitario (5+)",
      loner_4: "Solitario (4+)",
      loner_3: "Solitario (3+)",
      loner_2: "Solitario (2+)",
      animal_savagery: "Animal Feroz",
      throw_team_mate: "Lanzar Compañero de Equipo",
      projectile_vomit: "Proyectil de Vómito",
      really_stupid: "Realmente Estúpido",
      regeneration: "Regeneración",
      unchannelled_fury: "Ira Descontrolada",
      no_hands: "Sin Manos",
      secret_weapon: "Arma Secreta",
      chainsaw: "Motosierra",
      ball_and_chain: "Bola y Cadena",
      pogo_stick: "Pogo Saltarín",
      swoop: "Planear",
      timmm_ber: "¡Tronco Va!",
      take_root: "Echar Raíces",
      plague_ridden: "Putrefacción de Nurgle",
      titchy: "Canijo",
      swarming: "Colarse",
      hypnotic_gaze: "Mirada Hipnótica",
      kick_team_mate: "Chutar Compañero",
      breath_fire: "Aliento de Fuego",
      bone_head: "Estúpido",
      pick_me_up: "Bebida Reconstituyente",
      decay: "Descomposición",
      trickster: "Embaucador",
      hit_and_run: "Golpear y Correr",
      my_ball: "Mi Balón",
      stab: "Apuñalar",
      drunkard: "Borracho",
      bloodlust: "Sed de Sangre",
      special: "Especial",
      niggling_injury: "Lesion Mal Curada (1)",
      niggling_injuries_2: "Lesion Mal Curada (2+)",
    },
    skill_hooks: {
      // Season 3
      eye_gouge: "EYE GOUGE",
      lethal_flight: "LETHAL F.",
      lone_fouler: "L. FOULER",
      put_the_boot_in: "P.T. BOOT IN",
      quick_foul: "QUICK FOUL",
      saboteur: "SABOTEUR",
      violent_innovateur: "VIOLENT IN.",
      bullseye: "BULLSEYE",
      give_and_go: "GIVE & GO",
      taunt: "TAUNT",
      steady_footing: "STEADY F.",
      punt: "PUNT",
      hatred: "HATRED",
      insignificant: "INSIGNIFIANT",
      no_ball: "NO BALL",
      unsteady: "UNSTEADY",

      bombardier: "BOMBARDE.",
      block: "PLACAR",
      dauntless: "AGALLAS",
      dirty_player_1: "SUCIO(+1)",
      dirty_player_2: "SUCIO(+2)",
      fend: "ZAFARSE",
      frenzy: "FURIA",
      kick: "PATADA",
      pro: "PRO",
      shadowing: "PERSEGUIR",
      strip_ball: "ROBAR BAL.",
      sure_hands: "M.SEGURAS",
      tackle: "PLA.DEF.",
      wrestle: "FORCEJEAR",
      catch: "ATRAPAR",
      diving_catch: "REC.HERO.",
      diving_tackle: "PLA.HERO.",
      dodge: "ESQUIVAR",
      defensive: "ROMP.DEF.",
      jump_up: "E.P.SALTO",
      leap: "SALTAR",
      safe_pair_of_hands: "P.CUERO",
      sidestep: "ECH.LADO",
      sneaky_git: "FURTIVO",
      sprint: "ESPRINTAR",
      sure_feet: "P.FIRMES",
      big_hand: "M.GRANDE",
      claws: "GARRAS",
      disturbing_presence: "PRES.PERT.",
      extra_arms: "BRAZOS AD.",
      foul_appearance: "APAR.ASQ.",
      horns: "CUERNOS",
      iron_hard_skin: "PIEL FÉR.",
      monstrous_mouth: "BOC.MONST.",
      prehensile_tail: "COLA PRÉ.",
      tentacles: "TENTÁCULOS",
      two_heads: "2 CABEZAS",
      very_long_legs: "PIER.M.L.",
      accurate: "PRECISIÓN",
      cannoneer: "CAÑONERO",
      cloud_burster: "PARTENUB.",
      dump_off: "PASE PREC.",
      fumblerooskie: "DEJADA",
      hail_mary_pass: "PASE LOCO",
      leader: "LÍDER",
      nerves_of_steel: "NERV.ACE.",
      on_the_ball: "A.A.BALÓN",
      pass: "PASAR",
      running_pass: "PASE CARR.",
      safe_pass: "PASE SEG.",
      arm_bar: "L.D.BRAZO",
      brawler: "LUCHADOR",
      break_tackle: "ABR.PASO",
      grab: "APARTAR",
      guard: "DEFENSA",
      juggernaut: "IMPARABLE",
      mighty_blow_1: "G.MORTÍ.(+1)",
      mighty_blow_2: "G.MORTÍ.(+2)",
      multiple_block: "PLA.MÚLT.",
      pile_driver: "CRUJIR",
      stand_firm: "MAN.FIRME",
      strong_arm: "BR.FUERTE",
      thick_skull: "CAB.DURA",
      ma_1p: "MO +1",
      st_1p: "FU +1",
      ag_1p: "AG +1",
      pa_1p: "CP +1",
      av_1p: "AR +1",
      ma_1m: "MO -1",
      st_1m: "FU -1",
      ag_1m: "AG -1",
      pa_1m: "CP -1",
      av_1m: "AR -1",
      animosity: "ANIMOSID.",
      stunty: "ESCURR.",
      right_stuff: "HUM.BALA",
      always_hungry: "S.HAMBR.",
      loner_5: "SOLIT.(5+)",
      loner_4: "SOLIT.(4+)",
      loner_3: "SOLIT.(3+)",
      loner_2: "SOLIT.(2+)",
      animal_savagery: "ANIMAL F.",
      throw_team_mate: "LANZAR CO.",
      projectile_vomit: "PR.VÓMITO",
      really_stupid: "R.ESTÚPIDO",
      regeneration: "REGEN.",
      unchannelled_fury: "IRA DESC.",
      no_hands: "SIN MANOS",
      secret_weapon: "ARMA SEC.",
      chainsaw: "MOTOSIER.",
      ball_and_chain: "B.CADENA",
      pogo_stick: "POGO S.",
      swoop: "PLANEAR",
      timmm_ber: "TRONCO VA",
      take_root: "ECH.RAÍCES",
      plague_ridden: "PU.NURGLE",
      titchy: "CANIJO",
      swarming: "COLARSE",
      hypnotic_gaze: "MIR.HIPNO.",
      kick_team_mate: "CHUTAR CO.",
      breath_fire: "AL.FUEGO",
      bone_head: "ESTÚPIDO",
      pick_me_up: "BEBIDA R.",
      decay: "DESCOMP.",
      trickster: "EMBAUCA",
      hit_and_run: "G.CORRER",
      my_ball: "MI BALÓN",
      stab: "APUÑALAR",
      drunkard: "BORRACHO",
      bloodlust: "S.SANGRE",
      special: "ESPECIAL",
      niggling_injury: "L.M.C.(1)",
      niggling_injuries_2: "L.M.C.(2+)",
    },
  };

  result.createBaseLabel = _createBaseLabel;
  parent.FantasyFootball = result;
  return parent;
})(TTG);

  window["TTG.FantasyFootball"] = "LOADED";
}

